import { createContext, useContext, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { moduleForPath, type ModuleId } from './modulesConfig';

/**
 * Route-derived active-module context (PRO-0340 / ADR-014 Amendment 1, T3). A
 * thin context over the pure `moduleForPath` selector — no new global store, no
 * persistence (the active module is recomputed from the URL each navigation, so
 * nothing is written to storage; §10). Consumers (`ModuleRail`, `ShellContent`)
 * read the active id to set `aria-current` and to choose the tier-2 nav.
 */
const ActiveModuleContext = createContext<ModuleId>('comms');

export function ActiveModuleProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const activeModuleId = moduleForPath(location.pathname);
  return <ActiveModuleContext.Provider value={activeModuleId}>{children}</ActiveModuleContext.Provider>;
}

export function useActiveModule(): ModuleId {
  return useContext(ActiveModuleContext);
}
